import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { makePointer } from '../../../api/_utils'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { computeOptions } from '../utils/computeData'
import { useUserFormContext } from '../utils/userFormContext'
import { resetRelatedFields, professionsFieldsToReset, specialitiesFieldsToReset } from './_utils'
import { useGetIdsReferencesQualifications } from '@toktokdoctech/tokapi-client'

const Qualification = () => {
    const { state } = useUserFormContext()
    const { control, setValue, watch } = useFormContextUser()

    const validRpps = watch('validRpps')
    const qualification = watch('qualification')
    const qualificationId = watch('qualificationId')

    const { data } = useGetIdsReferencesQualifications()

    useEffect(() => {
        if (!validRpps || !qualification || qualificationId || !data?.qualifications?.edges) return

        const matchedQualification = data.qualifications.edges.find((el) => el?.node?.name === qualification)
        const matchedQualificationId = matchedQualification?.node?.objectId

        if (matchedQualificationId) {
            setValue('qualificationId', matchedQualificationId, { shouldValidate: true })
            setValue('qualificationPointer', makePointer('Qualification', matchedQualificationId), { shouldValidate: true })
        }
    }, [validRpps, qualification, qualificationId, data, setValue])

    const handleChange = (qualification: string) => {
        const selectedQualification = data?.find((el) => el?.name === qualification)

        const qualificationId = selectedQualification?.id ?? ''
        const qualificationName = selectedQualification?.name ?? ''

        const qualificationPointer = makePointer('Qualification', qualificationId)

        setValue('qualificationPointer', qualificationPointer)
        setValue('qualification', qualificationName)
        setValue('qualificationId', qualificationId)

        const fieldsToReset = [...professionsFieldsToReset, ...specialitiesFieldsToReset]
        resetRelatedFields(fieldsToReset, setValue)
    }

    const computedQualifications = React.useCallback(() => {
        if (data) {
            const qualifications = computeOptions(data)
            return qualifications
        }
        return []
    }, [data])

    return (
        <Controller
            control={control}
            name="qualification"
            rules={{
                validate: (val) => Boolean(val),
                required: 'Cette information est obligatoire et n’a pas été renseignée',
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="select"
                    label="Qualification professionnelle"
                    type="default"
                    name={field.name}
                    status={{
                        error,
                        valid: Boolean(field.value) || (!field.value && validRpps),
                    }}
                    required
                    locked={state.rppsLocked}
                    readonly={state.rppsLocked}
                    placeholder="Qualification professionnelle"
                    value={field.value || undefined}
                    onChange={(e) => {
                        if (e) {
                            handleChange(e)
                        }
                    }}
                    options={computedQualifications()}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default Qualification
